export default "__VITE_ASSET__7DbQGd0l__"